/* @twid_ai_start */
import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';

const Header = () => {
  return (
    <AppBar position="sticky" color="primary">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Influencers Dashboard
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
/* @twid_ai_end */ 